.wrapper {
  overflow-x: hidden !important;

  :global(.ant-drawer-body) {
    padding: 0;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  :global(ul.ant-menu.ant-menu-inline) {
    border-inline-end: 0;
  }

  :global(.ant-drawer-header) {
    padding: 0;
  }

  :global(.ant-drawer-close.ant-drawer-close-end) {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}
